import api from './apiClient';

const apiCreateBillingCheckout = async ({ email, userIp } = {}) => {
    const response = await api.post('/api/captions/billing/create-checkout', {
        email,
        userIp,
    });
    return response.data;
};

export default apiCreateBillingCheckout;
